import { curveStepAfter } from 'd3-shape';
import { Curve } from './curve';
export const HV = (options, context) => {
    return Curve(Object.assign({ curve: curveStepAfter }, options), context);
};
HV.props = Object.assign(Object.assign({}, Curve.props), { defaultMarker: 'hv' });
//# sourceMappingURL=hv.js.map